import { useState } from "react"
import { Modal, Button, TextInput, Textarea, Group, Alert, Text, Title } from "@mantine/core"
import { PhoneNumberInput, validatePhoneNumber } from "~/forms/components/PhoneNumberInput"
import { useForm } from "@mantine/form"
import { notEmpty } from "~/forms/utils"
import { trpc } from "~/trpc/client"
import { brand } from "~/brand"
import { Message } from "tabler-icons-react"

export const ContactModal = () => {
  const [opened, setOpened] = useState(false)

  const form = useForm<{
    name: string
    email: string
    phone: string
    message: string
  }>({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },
    validate: {
      name: (value) => (notEmpty(value) ? null : "Please enter your name"),
      email: (value) => (notEmpty(value) ? null : "Please enter your email address"),
      phone: (value) => (notEmpty(value) ? validatePhoneNumber(value) : null), // Optional
      message: (value) => (notEmpty(value) ? null : "Please enter your message"),
    },
  })

  const [contactModalSubmitted, setContactModalSubmitted] = useState(false)
  const submitContactModal = trpc.useMutation("landing.submitContactModal")

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setOpened(false), setContactModalSubmitted(false)
        }}
        title={<Title order={3}>Contact us</Title>}
      >
        <Text mb="md">
          Leave us your questions and we&apos;ll get back to you as soon as possible!
        </Text>
        {!contactModalSubmitted && (
          <form
            onSubmit={form.onSubmit(async () => {
              await submitContactModal.mutateAsync(
                {
                  name: form.values.name,
                  email: form.values.email,
                  phone: form.values.phone,
                  message: form.values.message,
                },
                {
                  onSuccess: () => {
                    setContactModalSubmitted(true)
                    form.reset()
                  },
                }
              )
            })}
          >
            <TextInput {...form.getInputProps("name")} label="Name" mb="md" />
            <TextInput {...form.getInputProps("email")} label="Email" mb="md" />
            <PhoneNumberInput form={form} field="phone" label="Phone Number" mb="md" />
            <Textarea {...form.getInputProps("message")} label="Message" mb="md" minRows={3} />

            <Group position="right">
              <Button type="submit" color="cyan" loading={submitContactModal.isLoading}>
                Submit
              </Button>
            </Group>
          </form>
        )}

        {contactModalSubmitted && (
          <Alert color="green">Your message has been received. We will contact you shortly.</Alert>
        )}

        {submitContactModal.isError && (
          <Alert color="red" mb="md">
            There was an error submitting the contact form. Please try again or{" "}
            <a href={`mailto:${brand.mailto}`}>contact us</a> if the problem persists.
          </Alert>
        )}
      </Modal>

      <Button
        color="cyan"
        radius={0}
        size="lg"
        sx={{
          textTransform: "uppercase",
          position: "fixed",
          bottom: "0px",
          right: "0px",
        }}
        mr="xl"
        onClick={() => setOpened(true)}
        leftIcon={<Message />}
      >
        Contact Us
      </Button>
    </>
  )
}
